<template>
    <!--begin::Modal-->

    <b-modal size="lg" id="newLocationModal" v-model="showModal"
             :title="locationId ? 'Update location' : 'Add new location'"
             @hidden="close">
        <b-container>
            <!--begin::Form-->
            <form class="m-form m-form--label-align-right">
                <div class="m-portlet__body">
                    <div class="m-form__content">
                        <div class="m-alert m-alert--icon alert alert-danger" role="alert" v-if="error"
                             id="m_form_1_msg">
                            <div class="m-alert__icon">
                                <i class="la la-warning"></i>
                            </div>
                            <div class="m-alert__text" v-html="message">
                            </div>
                            <div class="m-alert__close">
                                <button type="button" class="close" @click="error=false" aria-label="Close"></button>
                            </div>
                        </div>
                    </div>
                    <div class="m-form__section m-form__section--first">
                        <div class="form-group m-form__group row">
                            <label class="col-lg-2 col-form-label">
                                Name
                            </label>
                            <div class="col-lg-9">
                                <input type="text" required="required" v-model="form.name" class="form-control m-input">
                                <span class="m-form__help"> Please enter name </span>
                            </div>
                        </div>
                        <div class="form-group m-form__group row">
                            <label class="col-lg-2 col-form-label">
                                Information
                            </label>
                            <div class="col-lg-9">
                                <textarea class="form-control m-input" v-model="form.information"
                                          placeholder="..." maxlength="250"></textarea>
                                <span class="m-form__help">Please enter information (max 250 characters)</span>
                            </div>
                        </div>
                        <div class="form-group m-form__group row">
                            <label class="col-lg-2 col-form-label">
                                Lat
                            </label>
                            <div class="col-lg-9">
                                <input type="number" step="any" class="form-control m-input" v-model="form.lat"/>
                                <span class="m-form__help">Please enter lat</span>
                            </div>
                        </div>

                        <div class="form-group m-form__group row">
                            <label class="col-lg-2 col-form-label">
                                Long
                            </label>
                            <div class="col-lg-9">
                                <input type="number" step="any" class="form-control m-input" v-model="form.long"/>
                                <span class="m-form__help">Please enter long</span>
                            </div>
                        </div>

                        <!-- <trail-select
                                @selectTrail="updateTrail"
                                v-bind:selectedTrail="currentTrail"
                        /> -->

                        <!-- <div class="form-group m-form__group row">
                            <label class="col-lg-2 col-form-label">
                                Order
                            </label>
                            <div class="col-lg-9">
                                <input type="number" :disabled="notInRoute" class="form-control m-input"
                                       v-model="order"/>
                                <span class="m-form__help">Please enter order</span>
                            </div>
                        </div> -->


                        <!-- <div class="form-group m-form__group row">
                            <label for="is-poi" class="col-lg-2 col-form-label">
                                Is POI?
                            </label>
                            <div class="col-lg-9">
                                <input type="checkbox" id="is-poi" v-model="isPOI"/>
                            </div>
                        </div>

                        <div v-if="isPOI" class="form-group m-form__group row">
                            <label for="not-in-route" class="col-lg-2 col-form-label">
                                Not in route?
                            </label>
                            <div class="col-lg-9">
                                <input type="checkbox" id="not-in-route" v-model="notInRoute"/>
                            </div>
                        </div> -->

                        <div class="form-group m-form__group row">
                            <label class="col-lg-2 col-form-label">
                                Point Icon (preferred size: 128x128 and .png transparent background)
                            </label>
                            <div class="col-lg-8">
                                <input type="file" id="icon" name="icon" class="form-control m-input"
                                       v-on:change="handleFile('icon')"/>
                                <span class="m-form__help">Add point icon (replace if icon already exists)</span>
                            </div>
                            <div class="col-lg-1">
                                <a target="_blank" :href="form.icon">
                                    <img v-if="form.icon" width="40" height="40" alt="point-icon"
                                         v-bind:src='form.icon'/>
                                </a>
                            </div>
                        </div>
                        <div class="form-group m-form__group row">
                            <label class="col-lg-2 col-form-label">
                                Gallery (preferred size: 1200x900)
                            </label>
                            <div class="col-lg-9">
                                <vue-dropzone v-model="gallery" class="m-dropzone m-dropzone--primary"
                                        ref="locationGalleryDropzone"
                                        id="locationDropzone"
                                        :options="dropOptions" :useCustomSlot="true"
                                        @vdropzone-complete="afterDropzoneComplete"
                                        @vdropzone-removed-file="afterDropzoneRemove">
                                    <div class="m-dropzone__msg dz-message needsclick">
                                        <h3 class="m-dropzone__msg-title">
                                            Drop file here or click to upload.
                                        </h3>
                                        <span class="m-dropzone__msg-desc">
                                            Only image files are allowed for upload
                                        </span>
                                    </div>
                                </vue-dropzone>
                                <span style="color: red" class="m-form__help">You have to re-upload all images if want to update gallery!</span>
                            </div>
                        </div>
                        <div class="form-group m-form__group row">
                            <label class="col-lg-2 col-form-label">
                                Active
                            </label>
                            <div class="col-lg-9">
                                <span class="m-switch m-switch--outline m-switch--icon m-switch--brand">
                                    <label>
                                        <input type="checkbox" v-model="form.active" :value="1">
                                        <span></span>
                                    </label>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
            <!--end::Form-->
        </b-container>
        <div slot="modal-footer">
            <button type="button" class="btn btn-secondary" @click="showModal=false">Close</button>
            <button type="button" class="btn btn-brand" @click="modifyLocation">{{ locationId ? 'Update' : 'Create'}}
            </button>
        </div>
    </b-modal>
    <!--end::Modal-->
</template>

<script>
    import LocationApi from '../../api/park_location';
    import vueDropzone from 'vue2-dropzone'
    import Settings from '../../constant/settings';
    import TrailSelect from '../trail/TrailSelect';
    import FileHelper from '../../service/file';
    import PropertyPreview from '../property/PropertyPreview';

    export default {
        components: {
            TrailSelect,
            vueDropzone,
            PropertyPreview
        },
        name: "location-modal",
        props: ['locationId'],
        data() {
            return {
                form: {},
                oldGallery: null,
                success: false,
                error: false,
                message: null,
                showModal: false,
                id: this.locationId,
                name: null,
                information: null,
                lat: null,
                long: null,
                order: null,
                trailId: null,
                currentTrail: null,
                gallery: null,
                updateGallery: [],
                icon: null,
                sound: null,
                previewIcon: null,
                fileHelper: FileHelper,
                notInRoute: false,
                isPOI: false,
                dropOptions: {
                    thumbnailHeight: 120,
                    thumbnailWidth: 120,
                    url: Settings.imageDropzoneUrl,
                    maxFilesize: 2, // MB
                    maxFiles: 10,
                    addRemoveLinks: true,
                    acceptedFiles: "image/*",
                }
            }
        },
        watch: {
            locationId(val) {
                if (val) {
                    LocationApi.getLocationDetail(this, val, (context) => {
                        if (context.location) {
                            this.form = context.location
                            if (context.location.icon) {
                                this.form.icon = apiUrl + '/assets' + JSON.parse(context.location.icon).path;
                            }

                            this.oldGallery = context.location.gallery;

                            if (context.location.gallery) {
                                let gallery = JSON.parse(context.location.gallery);
                                gallery.images.forEach((image) => {
                                    let url = apiUrl + '/assets' + image.path;
                                    this.$refs.locationGalleryDropzone.manuallyAddFile(image, url);
                                });
                            }

                        //     this.name = context.location.name;
                        //     this.information = context.location.information;
                        //     this.lat = context.location.lat;
                        //     this.long = context.location.long;
                        //     this.trailId = context.location.trail_id;
                        //     this.currentTrail = context.location.trail_id;
                        //     this.distance = context.location.distance;
                        //     //this.gallery = context.location.gallery;
                        //     this.order = context.location.order;
                        //     this.icon = context.location.icon;
                        // this.sound = context.location.sound;
                        //     this.isPOI = !!+context.location.is_poi;
                        //     this.notInRoute = !!+context.location.not_in_route;
                        // this.oldGallery = context.location.gallery;
                        //     if (context.location.icon) {
                        //         this.icon = apiUrl + '/assets' + JSON.parse(context.location.icon).path;
                        //     }
                        }
                    })
                }
            },
        },
        methods: {
            modifyLocation() {
                this.error = false;
                let data = this.form

                data.gallery = this.gallery

                if (this.locationId) {
                    Object.keys(data).forEach(item => {
                        if (!data[item] || (data[item] && typeof (data[item]) === 'string' && data[item].includes('uploads')) ) {
                            delete (data[item]);
                        }
                    });

                    if(!this.form.active) {
                        data.active = 0;
                    } else {
                        data.active = 1;
                    }

                    data.oldGallery = this.oldGallery;

                    LocationApi.updateLocation(this, this.locationId, data, (context) => {
                        if (context.success) {
                            this.close();
                            this.$emit('show-update-success-alert');
                        }
                    })
                } else {
                    LocationApi.createLocation(this, data, (context) => {
                        if (context.success) {
                            this.close();
                            this.$emit('show-create-success-alert');
                        }
                    })
                }
            },
            resetData() {
                this.form = {}
                if(this.$refs.locationGalleryDropzone) {
                    this.$refs.locationGalleryDropzone.removeAllFiles();
                }
            },
            close() {
                this.resetData();
                this.$emit('clear-id');
                this.error = false;
                this.showModal = false;
            },
            updateTrail(id) {
                this.trailId = id;
            },

            handleFile(id) {

                let file = document.querySelector('#' + id);

                if (typeof file.files[0] != 'undefined') {
                    this.fileHelper.getBase64(file.files[0], this, (context) => {
                        if (context) {
                            if (id === 'icon') {
                                this.form.icon = context.currentFile;
                            }
                        }
                    });
                } else {
                    this.currentFile = null;
                }
            },
            afterDropzoneComplete(file) {
                if (this.gallery) {
                    this.gallery.push(file.dataURL);
                } else {
                    if ((typeof file.manuallyAdded !== 'undefined' && file.manuallyAdded === true)) {

                    } else {
                        if (typeof file !== 'undefined') {
                            this.gallery = [];
                            this.gallery.push(file.dataURL);
                        }
                    }
                }
            },
            afterDropzoneRemove(file) {
                if ((typeof file.manuallyAdded !== 'undefined' && file.manuallyAdded === true)) {
                    let removeFileName = file.name;
                    if (this.oldGallery) {
                        let oldGallery = JSON.parse(this.oldGallery).images;

                        oldGallery.forEach((image, index) => {
                            if (image.name === removeFileName) {
                            oldGallery.splice(index, 1);
                        }
                    });
                        if (oldGallery.length === 0) {
                            this.oldGallery = null;
                        } else {
                            this.oldGallery = JSON.stringify({'images': oldGallery});
                        }
                    }
                } else {
                    let index = this.gallery.indexOf(file.dataURL);
                    if (index > -1) {
                        this.gallery.splice(index, 1);
                    }
                }
                console.log(this.oldGallery);
            },
        }
    }
</script>